import { Card as MuiCard, CardProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { WithMobile } from './types';

export const Card = styled(MuiCard)<WithMobile<CardProps>>`
  margin: ${({ $isMobile }) => ($isMobile ? '24px 0' : '40px 0')};
`;
